import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import AOS from 'aos';
import '@fortawesome/fontawesome-free/css/all.css';
import './assets/tailwind.css'
import prerenderPlugin from './plugins/prerender'

AOS.init({
  once: true, // Animation only once
  duration: 1000, // Duration par défaut
});

// Créer l'app Vue
const app = createApp(App)

// Enregistrer les plugins
app.use(store)
app.use(router)
app.use(prerenderPlugin)

// Monter l'app
app.mount('#app')
